import type { ButtonProps } from '@enlighten/design-system/dist/Button';
import type { StaticImageData } from 'next/image';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Image from 'next/image';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Link from 'next/link';
import { type ComponentProps, createElement, type ReactElement } from 'react';

import GnbBanner01 from '@/assets/images/banners/gnb/banner_01.png';
import GnbBanner05 from '@/assets/images/banners/gnb/banner_05.png';
import GnbBanner08 from '@/assets/images/banners/gnb/banner_08.png';
import GnbBanner09 from '@/assets/images/banners/gnb/banner_09.png';
import GnbBanner10 from '@/assets/images/banners/gnb/banner_10.png';
import ApartmentBgTop from '@/assets/images/pages/apartment/bg_top.jpg';
import BizFinanceBgTop from '@/assets/images/pages/bizfinance/bg_top.jpg';
import BizKingBgTop from '@/assets/images/pages/bizking/bg_top.jpg';
import ExchangeBgTop from '@/assets/images/pages/exchange/bg_top.jpg';
import ExchangeBgTopMobile from '@/assets/images/pages/exchange/bg_top_mobile.png';
import FinanceBgTop from '@/assets/images/pages/finance/bg_top.jpg';
import HouseBgTop from '@/assets/images/pages/house/bg_top.png';
import KingBgTop from '@/assets/images/pages/king/bg_top.png';
import LoanBgTop from '@/assets/images/pages/loan/bg_top.jpg';
import ProductBgTop from '@/assets/images/pages/product/bg_top.jpg';
import PvDrBgTop from '@/assets/images/pages/pvdr/bg-top.png';
import RE100BgTop from '@/assets/images/pages/re100/bg_top.jpg';
import RE100SubsBgTop from '@/assets/images/pages/re100subs/bg_top.jpg';
import RemoteMonitoringControlBgTop from '@/assets/images/pages/remote-monitoring-control/bg_top.png';
import RepoweringBgTop from '@/assets/images/pages/repowering/bg_top.png';
import RescoBgTop from '@/assets/images/pages/resco/bg_top.png';
import RooftopBgTop from '@/assets/images/pages/rooftop/bg_top.jpg';
import SiteSaleBgTop from '@/assets/images/pages/site-sale/bg_top.jpg';
import SolarBusinessBgTop from '@/assets/images/pages/solar-business/bg_top.png';
import SolarSupportBgTop from '@/assets/images/pages/solar-support/bg_top.png';
import TradingBgTop from '@/assets/images/pages/trading/background-top.png';
import VppBgTop from '@/assets/images/pages/vpp/bg_top.png';
import VppBgTopMobile from '@/assets/images/pages/vpp/bg_top_mobile.png';
import ZeroCapitalFactoringBgTop from '@/assets/images/pages/zero-capital-factoring/bg_top.png';
import InquireModal from '@/components/pages/trading/InquireModal';

type MenuBannerImageProps = ComponentProps<typeof Image>;
type MenuLinkProps = Pick<ComponentProps<typeof Link>, 'target' | 'title'> & { href: string };

export interface NavigationItem {
	title: string;
	linkProps?: MenuLinkProps;
	subMenuList: (
		| {
				title: string;
				subTitle: string;
				linkProps: MenuLinkProps;
		  }
		| {
				title: string;
				subTitle: string;
				banners: {
					title: string;
					imageProps: MenuBannerImageProps;
					linkProps: MenuLinkProps;
				}[];
		  }
		| {
				title: string;
				subTitle: string;
				children: {
					title: string;
					subTitle?: string;
					linkProps: MenuLinkProps;
				}[];
		  }
	)[];
	banner?: {
		imageProps: MenuBannerImageProps;
		linkProps: MenuLinkProps;
	}[];
}

export const navigationList: NavigationItem[] = [
	{
		title: '회사소개',
		subMenuList: [
			{
				title: '엔라이튼',
				subTitle: '에너지 기후테크 기업 알아보기',
				linkProps: {
					href: '/company',
				},
			},
			{
				title: '인재 채용 ↗',
				subTitle: '채용 중인 분야 확인하기',
				linkProps: {
					href: 'https://enlighten-co-ltd.notion.site/ENlighten-2e802b379ed48049aa26daa708a65787',
					target: '_blank',
				},
			},
			{
				title: '윤리경영',
				subTitle: '공정하고 투명한 경영활동',
				linkProps: {
					href: '/ethical',
				},
			},
		],
		banner: [
			{
				imageProps: {
					src: GnbBanner01,
					alt: '엔라이튼과 함께 할 동료를 찾고 있어요',
				},
				linkProps: {
					href: 'https://enlighten-co-ltd.notion.site/ENlighten-2e802b379ed48049aa26daa708a65787',
					target: '_blank',
				},
			},
		],
	},
	{
		title: '태양광사업',
		subMenuList: [
			{
				title: '태양광 발전사업',
				subTitle: '튼튼한 시공, 금융 솔루션으로 수익성 극대화',
				linkProps: {
					href: '/solar-business',
				},
			},
			// {
			// 	title: '사업 부지 검토',
			// 	subTitle: '비어있는 땅과 지붕으로 고정수입 만들기',
			// 	linkProps: {
			// 		href: '/fs',
			// 	},
			// },
			// {
			// 	title: '무자본 발전사업 팩토링',
			// 	subTitle: '초기 자금 부담 없이 시작하는 발전사업',
			// 	linkProps: {
			// 		href: '/zero-capital-factoring',
			// 	},
			// },
			{
				title: 'RE100 태양광 구독',
				subTitle: '초기 비용 없는 RE100 이행 및 전기료 절감',
				linkProps: {
					href: '/re100subs',
				},
			},
			{
				title: '정부지원사업',
				subTitle: '정부지원사업으로 투자비용 절감',
				linkProps: {
					href: '/solar-support',
				},
			},
			{
				title: '지붕 임대사업',
				subTitle: '고정 임대료와 안정적 지붕 관리까지',
				linkProps: {
					href: '/rooftop',
				},
			},
			{
				title: '햇빛소득마을 사업',
				subTitle: '햇빛연금으로 우리 마을도 든든하게',
				linkProps: {
					href: '/resco',
				},
			},
			// {
			// 	title: '솔라브리지 ↗',
			// 	subTitle: '평균 수익률 11% 발전사업 투자하기',
			// 	linkProps: {
			// 		href: 'https://www.solarbridge.kr',
			// 		target: '_blank',
			// 	},
			// },
		],
		banner: [
			{
				imageProps: {
					src: GnbBanner10,
					alt: '재생에너지 투자 플랫폼 솔라브리지',
				},
				linkProps: {
					href: 'https://www.solarbridge.kr',
					target: '_blank',
				},
			},
			{
				imageProps: {
					src: GnbBanner08,
					alt: '한화손보 \u00d7 TPA코리아 태양광발전소종합보험',
				},
				linkProps: {
					href: '/insurance/hanwha',
				},
			},
		],
	},
	{
		title: '자산관리',
		subMenuList: [
			{
				title: '발전소 매각',
				subTitle: '시장 최고 조건으로 발전사업 매각하기',
				linkProps: {
					href: '/site-sale',
				},
			},
			{
				title: '리파워링',
				subTitle: '오래된 발전소의 다음 방향',
				linkProps: {
					href: '/repowering',
				},
			},
			{
				title: '발전왕',
				subTitle: '스마트폰으로 간편하게 발전소 관리하기',
				linkProps: {
					href: '/king',
				},
			},
			{
				title: '발전왕 모니터링(RTU)',
				subTitle: '알아서 다 챙겨주는 발전소 모니터링',
				linkProps: {
					href: '/rtu',
				},
			},
			{
				title: '발전왕 비즈',
				subTitle: '안전관리자를 위한 발전소 통합 관리 서비스',
				linkProps: {
					href: '/bizking',
				},
			},
			// TODO(비공개): 임시로 숨기기 위해 해당 방식으로 처리
			// {
			// 	title: '스마트 O&M',
			// 	subTitle: '예초, 진단, 안전관리, 정산까지 한 번에!',
			// 	linkProps: {
			// 		href: '/smart-om',
			// 	},
			// },
			{
				title: '원격감시제어',
				subTitle: '1~3MW급 발전소, 더 효율적으로 관리',
				linkProps: {
					href: '/remote-monitoring-control',
				},
			},
			{
				title: '태양광종합보험',
				subTitle: '화재부터 자연재해까지 폭넓게 보장받기',
				linkProps: {
					href: '/insurance/egi',
				},
			},
		],
		banner: [
			{
				imageProps: {
					src: GnbBanner08,
					alt: '한화손보 \u00d7 TPA코리아 태양광발전소종합보험',
				},
				linkProps: {
					href: '/insurance/hanwha',
				},
			},
			{
				imageProps: {
					src: GnbBanner09,
					alt: 'EGi공제보험 태양광종합공제보험',
				},
				linkProps: {
					href: '/insurance/egi',
				},
			},
		],
	},
	{
		title: '전력거래',
		subMenuList: [
			{
				title: '기업 재생에너지 조달',
				subTitle: '직접 PPA, REC 조달을 통한 기업 재생에너지 조달 파트너',
				linkProps: {
					href: '/trading',
				},
			},
			{
				title: '수요관리 (DR)',
				subTitle: '공장/건물 전력 사용 절감을 통한 수익 창출',
				linkProps: {
					href: '/pvdr',
				},
			},
			{
				title: '전력중개',
				subTitle: '발전량 예측제도 참여를 통한 수익 창출',
				linkProps: {
					href: '/exchange',
				},
			},
			{
				title: '배전망 ESS 사업',
				subTitle: '접속 대기 중인 발전소를 위한 자문 서비스',
				linkProps: {
					href: '/grid-vpp',
				},
			},
			{
				title: 'VPP',
				subTitle: '예측·제어·거래를 하나로 잇는 VPP 플랫폼',
				linkProps: {
					href: '/vpp',
				},
			},
		],
	},
	{
		title: '인사이트',
		subMenuList: [
			{
				title: '인사이트',
				subTitle: '에너지 핵심 트렌드 모아보기',
				linkProps: {
					href: '/insight',
				},
			},
			// {
			// 	title: '뉴스레터',
			// 	subTitle: '하루도 놓치면 안 될 에너지 소식 받기',
			// 	linkProps: {
			// 		href: '/news-letter',
			// 	},
			// },
			{
				title: '시장동향',
				subTitle: 'SMP+REC 가격 동향 확인하기',
				linkProps: {
					href: '/market',
				},
			},
			{
				title: '보도자료',
				subTitle: '엔라이튼 보도자료 모아보기',
				linkProps: {
					href: '/press-release',
				},
			},
		],
		banner: [
			{
				imageProps: {
					src: GnbBanner05,
					alt: '최신 에너지 소식, 메일로 받아보세요!',
				},
				linkProps: {
					href: '/news-letter',
				},
			},
		],
	},
	{
		title: '고객센터',
		linkProps: {
			href: 'https://support.enlighten.kr/hc/ko',
			target: '_blank',
		},
		subMenuList: [],
	},
];

interface InquireLinkButtonProps extends Omit<ButtonProps, 'LinkComponent' | 'role' | 'children'> {
	href: string;
	target?: HTMLAnchorElement['target'];
	title: string;
}

type InquireButtonProps = InquireLinkButtonProps | ReactElement;

export interface SubLayoutValue {
	pathname: string;
	subTitle1?: string;
	mobileSubTitle1?: string;
	title: string;
	subTitle2?: string;
	inquire: InquireButtonProps | InquireButtonProps[] | { desktop: InquireButtonProps | InquireButtonProps[]; mobile: InquireButtonProps | InquireButtonProps[] };
	image: StaticImageData;
	mobileImage?: StaticImageData;
}

export const subLayoutValueList: SubLayoutValue[] = [
	{
		pathname: '/finance',
		title: '금융 자문',
		subTitle2: '사업의 핵심은 결국, 금융! 사업의 특성에 맞게 금융을 해결합니다.',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=10908268950041',
			target: '_blank',
			title: '금융 자문 시작하기',
		},
		image: FinanceBgTop,
	},
	{
		pathname: '/rooftop',
		title: '지붕 임대',
		subTitle1: '안정적 임대료, 지붕에서 시작되는 변화',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=10924492096281',
			target: '_blank',
			title: '상담 신청하기',
		},
		image: RooftopBgTop,
	},
	{
		pathname: '/solar-business',
		title: '태양광 발전사업',
		subTitle1: '안정적인 수익을 창출하는',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=50994131839641',
			target: '_blank',
			title: '문의하기',
		},
		image: SolarBusinessBgTop,
	},
	{
		pathname: '/solar-support',
		title: '정부지원사업',
		subTitle1: '정부지원사업으로 투자비용 절감',
		inquire: {
			href: '#solar-support-form',
			title: '상담 신청하기',
		},
		image: SolarSupportBgTop,
	},
	{
		pathname: '/resco',
		title: '햇빛소득마을 사업',
		subTitle1: '우리 마을에도 햇빛연금을! 주민주도형 마을 태양광',
		mobileSubTitle1: '우리 마을에도 햇빛연금을!\n주민주도형 마을 태양광',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=57666104198809',
			target: '_blank',
			title: '문의하기',
		},
		image: RescoBgTop,
	},
	{
		pathname: '/house',
		title: '주택용 태양광 구독',
		subTitle2: '초기 비용부담 없이 전기요금 80% 절감해보세요',
		inquire: {
			href: 'https://forms.gle/e9gZAVrWcJ5DoyR67',
			target: '_blank',
			title: '문의하기',
		},
		image: HouseBgTop,
	},
	{
		pathname: '/apartment',
		title: '아파트 태양광',
		subTitle2: '아파트에 태양광을 설치하고, 친환경 아파트 사업에 참여하세요.',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=16730022471833',
			target: '_blank',
			title: '문의하기',
		},
		image: ApartmentBgTop,
	},
	{
		pathname: '/king',
		subTitle1: '발전사업주 5명 중 1명이 쓰는 발전왕',
		title: '태양광 건설부터 관리까지, 누구나 쉽게',
		inquire: {
			href: 'https://king.enlighten.kr/on-boarding',
			target: '_blank',
			title: '시작하기',
		},
		image: KingBgTop,
	},
	{
		pathname: '/remote-monitoring-control',
		subTitle1: '1~3MW급 발전소, 더 효율적으로 관리',
		title: '원격감시제어',
		inquire: {
			desktop: {
				href: 'tel:02-6931-0901',
				target: '_blank',
				title: '전화 상담 02-6931-0901',
			},
			mobile: {
				href: 'tel:02-6931-0901',
				target: '_blank',
				title: '전화 상담',
			},
		},
		image: RemoteMonitoringControlBgTop,
	},
	{
		pathname: '/exchange',
		subTitle1: '손 쉽게 확보하는 추가 수익',
		title: '전력중개',
		inquire: [
			{
				href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=16730758901529',
				target: '_blank',
				title: '신청하기',
			},
			{
				href: 'tel:02-6231-1504',
				title: '전화 상담하기',
				variant: 'outlined',
				sx: {
					':hover': {
						backgroundColor: 'white',
						borderColor: 'primary.main',
					},
				},
			},
		],
		image: ExchangeBgTop,
		mobileImage: ExchangeBgTopMobile,
	},
	{
		pathname: '/vpp',
		subTitle1: '흩어진 3만 개의 발전소를 하나의 발전소처럼',
		title: 'VPP',
		inquire: {
			href: '#vpp-form',
			title: '내 발전소 VPP 참여 상담 신청하기',
		},
		image: VppBgTop,
		mobileImage: VppBgTopMobile,
	},
	{
		pathname: '/bizfinance',
		title: '기업 금융',
		subTitle2: '사업별 특성을 고려한 맞춤 금융 솔루션을 제공합니다.',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=10908268950041',
			target: '_blank',
			title: '문의하기',
		},
		image: BizFinanceBgTop,
	},
	{
		pathname: '/loan',
		title: '시공비 100% 여신',
		subTitle2: '담보, 보증 부담을 최소화한 상품으로 건설 기간 현금 확보 부담을 없애드립니다.',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=10908268950041',
			target: '_blank',
			title: '문의하기',
		},
		image: LoanBgTop,
	},
	// TODO(비공개): 임시로 숨기기 위해 해당 방식으로 처리
	// {
	// 	pathname: '/smart-om',
	// 	title: '스마트 O&M',
	// 	subTitle2: '예초, 진단, 안전관리, 정산까지 한 번에!',
	// 	inquire: {
	// 		href: 'https://support.enlighten.kr/hc/ko/categories/11180113308313-O-M',
	// 		target: '_blank',
	// 		title: '상품 확인하기',
	// 	},
	// 	image: SmartOmBgTop,
	// },
	{
		pathname: '/zero-capital-factoring',
		title: '무자본 발전사업 팩토링',
		subTitle1: '초기 자금 부담 없이 시작하는 발전사업',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=50994131839641',
			target: '_blank',
			title: '상담 신청하기',
		},
		image: ZeroCapitalFactoringBgTop,
	},
	{
		pathname: '/product',
		title: '기자재 특가·여신',
		subTitle2: '경쟁력 있는 가격으로 태양광 모듈과 인버터를 확보하고, 자금 조달 고민까지 한번에 해결합니다.',
		inquire: {
			href: '#manufacturer',
			title: '제조사 선택하기',
		},
		image: ProductBgTop,
	},
	{
		pathname: '/bizking',
		subTitle1: '시공사, 전기안전관리자를 위한',
		title: '발전왕 비즈',
		inquire: {
			href: 'https://forms.gle/yqyKdgV7JGTikhAo8',
			target: '_blank',
			title: '체험 해보기',
		},
		image: BizKingBgTop,
	},
	{
		pathname: '/re100subs',
		title: 'RE100 태양광 구독',
		subTitle1: 'RE100 이행 · 전기료 절감까지 한 번에',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=26017104459801',
			target: '_blank',
			title: '문의하기',
		},
		image: RE100SubsBgTop,
	},
	{
		pathname: '/re100',
		subTitle1: '믿을 수 있는 기업의 장기 파트너',
		title: '계획 수립부터 인증까지 함께하는 RE100 이행 서비스',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=16771384877593',
			target: '_blank',
			title: 'RE100 이행 문의하기',
		},
		image: RE100BgTop,
	},
	{
		pathname: '/pvdr',
		subTitle1: '전기를 가장 싸게 쓰는 방식',
		title: '전력 공급자 변경 및\n사용량 거래',
		inquire: {
			href: 'https://forms.gle/vQoCHTFLWgaB5sfv9',
			target: '_blank',
			title: '문의하기',
		},
		image: PvDrBgTop,
	},
	{
		pathname: '/trading',
		subTitle1: '넷제로 실현을 위한 기업의 핵심 전략',
		title: '재생 에너지 조달',
		inquire: createElement(InquireModal, {
			title: '문의하기',
			sx: { marginTop: 2, paddingX: '23px' },
		}),
		image: TradingBgTop,
	},
	{
		pathname: '/repowering',
		subTitle1: '오래된 발전소의 다음 방향',
		title: '리파워링',
		inquire: {
			href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=62142664732057',
			target: '_blank',
			title: '문의하기',
		},
		image: RepoweringBgTop,
	},
	{
		pathname: '/site-sale',
		subTitle1: '다양한 형태의 사업을 시장 최고의 조건으로 매입',
		mobileSubTitle1: '다양한 형태의 사업을\n시장 최고의 조건으로 매입',
		title: '발전소 매각',
		inquire: {
			href: '#site-sale-form',
			title: '상담 신청하기',
		},
		image: SiteSaleBgTop,
	},
];

export const enNavigationList = [
	{
		href: '/en/about',
		title: 'About Us',
	},
	{
		href: '/en/solution',
		title: 'Solution',
	},
	{
		href: '/en/platform-tech',
		title: 'Platform & Tech',
	},
	{
		href: '/en/insights',
		title: 'Insights',
	},
	{
		href: '/en/ethical',
		title: 'Ethical Management',
	},
];

/** ================================== DEPRECATED ================================== */
/** Deprecated Navigation Items */
// {
// 	title: '기업 금융',
// 	subTitle: '업계 1위 태양광 금융 알아보기',
// 	linkProps: {
// 		href: '/bizfinance',
// 	},
// },
// {
// 	title: '시공비 100% 여신',
// 	subTitle: '최대 9억원까지 시공비 선지급 받기',
// 	linkProps: {
// 		href: '/loan',
// 	},
// },
// {
// 	title: '기자재 특가•여신',
// 	subTitle: '업계 최저가로 기자재 구매하기',
// 	linkProps: {
// 		href: '/product',
// 	},
// },
// {
// 	title: '태양광 운용리스',
// 	subTitle: '초기 투자비 없이 전기료 절감하기',
// 	linkProps: {
// 		href: '/lease',
// 	},
// },
// {
// 	title: 'RE100',
// 	subTitle: '지속가능한 발전 실현하기',
// 	linkProps: {
// 		href: '/re100',
// 	},
// },
// {
// 	title: '수요자원',
// 	subTitle: '아낀 전력으로 수익 창출하기',
// 	linkProps: {
// 		href: '/dr',
// 	},
// },
// {
// 	title: '프로젝트 세미나',
// 	subTitle: '프로젝트 사례 강연',
// 	linkProps: {
// 		href: '/projectseminar',
// 	},
// },
// {
// 	title: '금융 자문',
// 	subTitle: '부족한 건설 자금 해결하기',
// 	linkProps: {
// 		href: '/finance',
// 	},
// },
// {
// 	title: '발전소 분양',
// 	subTitle: '엄선된 발전사업 추천받기',
// 	linkProps: {
// 		href: '/owners',
// 	},
// },
// {
// 	title: '주택용 태양광 구독',
// 	subTitle: '우리집 전기요금 80% 절감하기',
// 	linkProps: {
// 		href: '/house',
// 	},
// },
// {
// 	title: '아파트 태양광',
// 	subTitle: '우리집 관리비 절감하기',
// 	linkProps: {
// 		href: '/apartment',
// 	},
// },
// {
// 	title: '발전소 매각',
// 	subTitle: '합리적인 가격에 발전소 매각하기',
// 	linkProps: {
// 		href: '/sell',
// 	},
// },
// {
// 	title: '충전왕 ↗',
// 	subTitle: '전기차 충전요금 최저가 확인하기',
// 	linkProps: {
// 		href: 'https://ev.enlighten.kr',
// 		target: '_blank',
// 	},
// },
// {
// 	title: '태양광 발전소 현황판',
// 	subTitle: '한 눈에 보는 우리 발전소',
// 	linkProps: {
// 		href: '/signage',
// 	},
// },

/** Deprecated Sub Layout Items */
// {
// 	pathname: '/sell',
// 	title: '발전사업 매각',
// 	subTitle2: '신속하게 결정하고, 명확하게 자금을 집행합니다.',
// 	inquire: {
// 		href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=16730334404761',
// 		target: '_blank',
// 		title: '매각 문의하기',
// 	},
// 	image: KingBgTop, // SellBgTop이 없어서 임시로 사용
// },
// {
// 	pathname: '/dr',
// 	title: '수요자원',
// 	subTitle2: '에너지와 ICT가 결합된 새로운 전력시장, 아낀 전기를 판매하여 수익을 창출하세요.',
// 	inquire: {
// 		href: 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=16771471769369',
// 		target: '_blank',
// 		title: '문의하기',
// 	},
// 	image: KingBgTop, // DrBgTop이 없어서 임시로 사용
// },
